import { render, staticRenderFns } from "./VendorCompaniesList.vue?vue&type=template&id=1f8cfa74&scoped=true&"
import script from "./VendorCompaniesList.vue?vue&type=script&lang=js&"
export * from "./VendorCompaniesList.vue?vue&type=script&lang=js&"
import style0 from "./VendorCompaniesList.vue?vue&type=style&index=0&id=1f8cfa74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8cfa74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VCard,VCardSubtitle,VCardTitle,VCol,VContainer,VDataTable,VRow,VTextField})
